module.exports = __webpack_public_path__ + "assets/img/empty_data.200648a5.png";